import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordinalSuffix',
    standalone: false
})
export class OrdinalSuffixPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }
        let qualityCheckNumberModulus10 = value % 10,
            qualityCheckNumberModulus100 = value % 100;
        if (qualityCheckNumberModulus10 === 1 && qualityCheckNumberModulus100 !== 11) {
            return 'st';
        }
        if (qualityCheckNumberModulus10 === 2 && qualityCheckNumberModulus100 !== 12) {
            return 'nd';
        }
        if (qualityCheckNumberModulus10 === 3 && qualityCheckNumberModulus100 !== 13) {
            return 'rd';
        }
        return 'th';
    }
}
